import { SERIES_API_PATH } from 'constants/api';
import { SeriesInterface } from '../../../domain/content/type/seriesType';
import { ApiService } from './apiService';

class SeriesApiService extends ApiService<SeriesInterface> {
  constructor() {
    super(SERIES_API_PATH);
  }
}

export const seriesApiService = new SeriesApiService();
